// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"237":"pages","597":"projects"}[chunkId] || chunkId) + "." + {"193":"f197a14b","237":"54199450","597":"7be396f5"}[chunkId] + ".css";
};